<template>
  <div class="mx-5 mt-5"><FamiglieArticolo /></div>
</template>
<script>
import FamiglieArticolo from "@/views/PRODUCTION/FamiglieArticolo/FamiglieArticolo.vue";
export default {
  name: "FamiglieArticoloEMAdapter",
  components: {
    FamiglieArticolo,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>